import { Injectable } from "@angular/core";
import { Api } from "../api/api";

import { Notice, Activity } from "../../models/notice";
import { Observable } from "rxjs/Observable";

@Injectable()
export class NoticesProvider {
  constructor(public api: Api) {}

  loadNotice(url: string): Observable<Notice[]> {
    return this.api
      .get(url, false)
      .map((posts) => posts.map((post) => new Notice(post)));
  }

  loadActivity(url: string, page: number): Observable<Activity[]> {
    return this.api
      .get(url, false, { page: page })
      .map((posts) => posts.map((post) => new Activity(post)));
  }

  readAll(url: string): Observable<any> {
    return this.api.post(url + "/read_all", {});
  }

  removeTopImageReviewingUser(activities: Activity[]): Activity[] {
    return activities.filter((targetActivity: Activity) => {
      if (!targetActivity.getUser().getTopImage().isBeforeReviewing())
        return targetActivity;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/notices/notices.ts